import React from 'react';

import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import CollectionSelect from 'components/application/CollectionSelect';

import { useCurrentActor } from 'components/contexts/CurrentActor';

export default function SelectDivision({
  assignableCompanies,
  onTeamCompanyOptionChange,
  sidePanelContext,
  team,
}) {
  const {
    division: {
      attributes: { primary: isPrimaryDivision },
    },
  } = useCurrentActor();

  const { t: i18nTShared } = useTranslation('common', {
    keyPrefix: 'shared',
  });

  const assignedDivision = assignableCompanies.find(
    (company) => company.id === `${team.companyId}`,
  );

  const assignableOptions = assignableCompanies.map((company) => ({
    value: company.id,
    label: company.attributes.name,
  }));

  const companyValue =
    assignedDivision ?
      { value: assignedDivision.id, label: assignedDivision.attributes.name }
    : '';

  return (
    <div className='tooltip-parent'>
      <CollectionSelect
        isDisabled={sidePanelContext === 'edit' || !isPrimaryDivision}
        isRequired={true}
        isSearchable={true}
        label={i18nTShared('division')}
        modifiers={['typeable-search', 'grey-disabled']}
        name='company'
        onChange={(e) => onTeamCompanyOptionChange(e.value)}
        options={assignableOptions}
        value={companyValue}
      />
    </div>
  );
}

SelectDivision.propTypes = {
  team: PropTypes.object.isRequired,
  sidePanelContext: PropTypes.string.isRequired,
  assignableCompanies: PropTypes.array.isRequired,
  onTeamCompanyOptionChange: PropTypes.func.isRequired,
};
